import { HStack, Text } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import { PriceWithDiscount } from '@/entities/product';
import { QuantityOption } from '../../lib/quantityUtils';

interface QuantityOptionCardProps {
  option: QuantityOption;
  price: number;
}

const QuantityOptionCard = ({ option }: QuantityOptionCardProps) => {
  const { t } = useTranslation();
  const { label, discount, description, totalPrice, discountPrice } = option;

  return (
    <>
      <HStack w='full'>
        <Text
          fontSize='md'
          fontWeight='bold'
          mr='auto'
        >
          {label}
        </Text>
        <PriceWithDiscount
          discountPercent={discount}
          discountPrice={discountPrice}
          fontSize='md'
          price={totalPrice}
        />
      </HStack>
      {description && (
        <Text
          fontSize='sm'
          ml='auto'
          mt='xs'
        >
          {t(description)}
        </Text>
      )}
    </>
  );
};

export default QuantityOptionCard;
